import { AnyCatcher } from "rxjs/internal/AnyCatcher";
import { DataBean } from "../DataBean";

export class ConfigAdmin extends DataBean {


    public async getFunctionalIDProperties(idLn: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.orange.bean.functional.FunctionalID_getFunctionalIDProperties_Number", [idLn]);
    }

    public async getFunctionalAreaByFunctionalID(idLn: any, State: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFunctionalAreaByFunctionalID_Number_Number", [idLn, State]);
    }
    public async getFunctionalAreaByEmployee(idAccount: any, state: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFunctionalAreaByEmployee_Number_Number", [idAccount, state]);
    }

    public async getFunctionalAreaByName(name: any, state: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFunctionalAreaByName_String_Number", [name, state]);
    }

    public async updateFunctionalAreaTreeToFunctionalID(idLnFunctionalArea: any, idLnFunctionalID: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateFunctionalAreaTreeToFunctionalID_Number_Number", [idLnFunctionalArea, idLnFunctionalID]);
    }

    public async getFunctionalArea(idLnFunctionalArea: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.FunctionalArea_getFunctionalArea_Number", [idLnFunctionalArea]);
    }

    public async getWorkGroupMemberCatalog(idLnFunctionalArea: number, idOffice: number, sate: number): Promise<any> {
        return this.getCustomService("BpmService", "java.util.List_getWorkGroupMemberCatalog_Number_Number_Number", [idLnFunctionalArea, idOffice, sate]);
    }

    public async updateFunctionalIDProperties(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.orange.bean.functional.FunctionalID_updateFunctionalIDProperties_com.orange.bean.functional.FunctionalID", [
            {
                DataBeanProperties: bean,
                DataBeanName: "com.orange.bean.functional.FunctionalID"
            }
        ]);
    }



}